import React from 'react';
import { workProcess } from '../data/mockData';

const HowWeWorkSection = () => {
  return (
    <section id="process" data-testid="process-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left sticky header */}
          <div className="lg:col-span-4 lg:sticky lg:top-32 lg:self-start">
            <p className="text-sm uppercase tracking-[0.2em] font-medium text-[#002FA7] mb-4">How It Works</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.2] text-[#0A0F1C] mb-5">
              Three Steps to Your Registered Trademark
            </h2>
            <p className="text-base text-[#4B5563] leading-relaxed">
              We've distilled the complexity of USPTO filing into a clear, transparent process. No guesswork, no confusion.
            </p>
          </div>

          {/* Right steps */}
          <div className="lg:col-span-8">
            {workProcess.map((step, index) => (
              <div key={step.id} data-testid={`process-step-${step.id}`} className="group flex gap-8 mb-0">
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 border-2 border-[#0A0F1C] text-[#0A0F1C] flex items-center justify-center text-2xl font-bold flex-shrink-0 group-hover:bg-[#0A0F1C] group-hover:text-white transition-all duration-500">
                    {step.step}
                  </div>
                  {index < workProcess.length - 1 && (
                    <div className="w-px flex-1 min-h-[80px] bg-[#E5E7EB]" />
                  )}
                </div>
                <div className="pb-16">
                  <h3 className="text-lg font-bold text-[#0A0F1C] mb-3">{step.title}</h3>
                  <p className="text-sm text-[#4B5563] leading-relaxed max-w-lg">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWeWorkSection;
